// Texto de uma regra de multa/juros: "2,00% a partir de 1 dia após o vencimento".
// Sem regra, diz isso explicitamente em vez de deixar o campo vazio.
import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"
import type { PaymentConfigurationCharge } from "@/types/payment-configurations"

import { formatCharge } from "../utils"

const prefix = "pages.paymentConfigurations"

interface ChargeRuleTextProps {
  /** Ausente = regra não configurada (o core omite o campo). */
  charge?: PaymentConfigurationCharge
  className?: string
}

export const ChargeRuleText = ({
  charge,
  className,
}: ChargeRuleTextProps) => {
  const { t, i18n } = useTranslation()
  const amount = formatCharge(charge, i18n.language)

  if (!charge || amount === null) {
    return (
      <span
        className={cn("text-muted-foreground", className)}
      >
        {t(`${prefix}.rules.none`)}
      </span>
    )
  }

  return (
    <span className={className}>
      <span className="font-semibold tabular-nums">
        {amount}
      </span>{" "}
      <span className="text-muted-foreground">
        {t(`${prefix}.rules.afterDays`, {
          count: charge.daysAfterDue,
        })}
      </span>
    </span>
  )
}
